import axios from 'axios'
import store from '../store/store'

export function getAcceptLanguage() {
  const defaultLocale = window.location.hostname.includes('shipmycargo')
    ? 'en'
    : 'tr';
  const storedLanguage = localStorage.getItem('language') || defaultLocale;
  return storedLanguage === 'tr' ? 'tr-TR' : 'en-US';
}

//axios.defaults.headers.common['Json-Naming'] = 'camel_case'
export default axios.create({
  baseURL: process.env.VUE_APP_API_URL, // projenin ana dizininde .env.production ve .env.development dosyalarında VUE_APP_API_URL tanımlanmış olmalıdır.
  timeout: 90 * 1000,
  headers: {
    'X-Custom-Header': 'foobar',
    'Accept-Language': getAcceptLanguage(),
  }
  // headers: {'Authorization':'headers'}

})
